/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolThunderstormIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-thunderstorm"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M7.9 24Q7.5 24 7.26 23.68Q7.03 23.35 7.15 22.98L7.83 21.02L6.13 21.02Q5.95 21.02 5.85 20.89Q5.75 20.75 5.8 20.57L6.85 17.73Q6.97 17.43 7.21 17.25Q7.45 17.07 7.78 17.07L9.45 17.07Q9.8 17.07 10 17.36Q10.2 17.65 10.05 18L9.22 19.88L10.95 19.88Q11.15 19.88 11.24 20.05Q11.32 20.23 11.2 20.4L8.68 23.7Q8.55 23.85 8.39 23.93Q8.22 24 7.9 24ZM15.18 22.8Q14.75 22.8 14.53 22.48Q14.3 22.15 14.43 21.75L14.88 20.45L13.07 20.45Q12.9 20.45 12.81 20.31Q12.72 20.18 12.78 20L13.6 17.73Q13.72 17.43 13.96 17.25Q14.2 17.07 14.53 17.07L16.23 17.07Q16.57 17.07 16.77 17.36Q16.98 17.65 16.82 18L16.25 19.3L17.9 19.3Q18.1 19.3 18.2 19.49Q18.3 19.68 18.18 19.85L15.97 22.52Q15.9 22.6 15.18 22.8ZM7.5 16.07Q5.08 16.07 3.38 14.38Q1.68 12.68 1.68 10.25Q1.68 8.1 3.09 6.47Q4.5 4.85 6.58 4.5Q7.42 3.05 8.85 2.24Q10.28 1.43 12 1.43Q14.28 1.43 16 2.89Q17.73 4.35 18.2 6.47Q19.95 6.72 21.14 8.06Q22.32 9.4 22.32 11.25Q22.32 13.25 20.91 14.66Q19.5 16.07 17.5 16.07Z" fill={color} />
    </svg>
  );
}
